import { render, staticRenderFns } from "./DebugControllerPage.vue?vue&type=template&id=67277c6f&scoped=true&"
import script from "./DebugControllerPage.vue?vue&type=script&lang=js&"
export * from "./DebugControllerPage.vue?vue&type=script&lang=js&"
import style0 from "./DebugControllerPage.vue?vue&type=style&index=0&id=67277c6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67277c6f",
  null
  
)

export default component.exports